"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const s = {
  Button: _styledComponents.default.div.withConfig({
    displayName: "SelectButton__Button",
    componentId: "design-system__sc-11dxs8t-0"
  })(["font-family:\"Roboto Condensed\",Helvetica,Arial,sans-serif;user-select:none;cursor:pointer;font-size:1rem;font-weight:400;text-decoration:none;text-align:center;color:#595959;border:1px solid #CFD8DC;border-radius:4px;padding:10px 15px;margin-right:8px;&:hover,&.active{color:#121212;border-color:#595959;}"]),
  ButtonContainer: _styledComponents.default.div.withConfig({
    displayName: "SelectButton__ButtonContainer",
    componentId: "design-system__sc-11dxs8t-1"
  })(["display:inline-block;position:relative;"]),
  Dropdown: _styledComponents.default.ul.withConfig({
    displayName: "SelectButton__Dropdown",
    componentId: "design-system__sc-11dxs8t-2"
  })(["margin:0;min-width:180px;position:absolute;list-style:none;top:calc(100% + 3px);left:0;border-image:initial;z-index:10001;transition:opacity .25s;max-height:460px;overflow:auto;height:0;opacity:0;&.active{background-color:rgb(255,255,255);box-shadow:rgb(0 0 0 / 10%) 0px 0px 5px;border:1px solid #ebebeb;padding:8px;height:auto;opacity:1;}"]),
  Item: _styledComponents.default.li.withConfig({
    displayName: "SelectButton__Item",
    componentId: "design-system__sc-11dxs8t-3"
  })(["display:flex;align-items:center;color:#6f6f6f;cursor:pointer;padding:8px;a{display:flex;align-items:center;text-decoration:none;color:#6f6f6f;padding:8px;margin:-8px;width:100%;}&:hover{background:#eef1f6;}"]),
  IconContainer: _styledComponents.default.span.withConfig({
    displayName: "SelectButton__IconContainer",
    componentId: "design-system__sc-11dxs8t-4"
  })(["margin-right:10px;"]),
  Search: _styledComponents.default.input.withConfig({
    displayName: "SelectButton__Search",
    componentId: "design-system__sc-11dxs8t-5"
  })(["box-sizing:border-box;background:rgb(255,255,255);border-style:solid;border-width:1px;border-color:rgb(204,204,204);border-radius:4px;color:rgb(89,89,89);font-family:Roboto,Helvetica,Arial,sans-serif;font-size:1rem;margin:0px;padding:9px 0.5rem 0.5rem;transition:all 100ms ease 0s;width:100%;margin-bottom:8px;margin-top:5px;&::placeholder{font-style:italic;}"])
};

const SelectButton = _ref => {
  let {
    title,
    options,
    placeholder
  } = _ref;
  const ref = (0, _react.useRef)(null);
  const refButton = (0, _react.useRef)(null);
  const [isOpen, setOpen] = (0, _react.useState)(false);
  const [selected, setSelected] = (0, _react.useState)(title);
  const [searchResult, setSearchResult] = (0, _react.useState)(options); // eslint-disable-next-line consistent-return

  const handleClick = (label, clickFunc) => {
    setSelected(label);
    setOpen(false);

    if (clickFunc) {
      clickFunc();
    }
  };

  const handleSearch = term => {
    setSearchResult(options.filter(_ref2 => {
      let {
        label
      } = _ref2;
      return label.toLowerCase().includes(term.toLowerCase());
    }));
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target) && refButton.current && !refButton.current.contains(event.target)) {
      setOpen(false);
    }
  };

  (0, _react.useEffect)(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(s.ButtonContainer, null, /*#__PURE__*/_react.default.createElement(s.Button, {
    onClick: () => setOpen(!isOpen),
    className: isOpen && 'active',
    ref: refButton
  }, selected), /*#__PURE__*/_react.default.createElement(s.Dropdown, {
    className: isOpen && 'active',
    ref: ref,
    "data-testid": "dropdown"
  }, options.length > 5 && /*#__PURE__*/_react.default.createElement(s.Search, {
    placeholder: placeholder || 'Search for options',
    "data-testid": "input-search",
    onChange: _ref3 => {
      let {
        target: {
          value
        }
      } = _ref3;
      return handleSearch(value);
    }
  }), searchResult.map(_ref4 => {
    let {
      label,
      icon,
      click,
      to
    } = _ref4;
    return /*#__PURE__*/_react.default.createElement(s.Item, {
      key: label,
      onClick: () => handleClick(label, click),
      "data-testid": "item"
    }, to ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      "data-testid": "item-link",
      to: to
    }, icon && /*#__PURE__*/_react.default.createElement(s.IconContainer, null, icon), label) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon && /*#__PURE__*/_react.default.createElement(s.IconContainer, null, icon), label));
  })));
};

SelectButton.propTypes = {
  title: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};
SelectButton.defaultProps = {
  placeholder: ''
};
var _default = SelectButton;
exports.default = _default;